import {
  convexClient,
  crossDomainClient,
} from '@convex-dev/better-auth/client/plugins'
import {
  emailOTPClient,
  organizationClient,
  twoFactorClient,
} from 'better-auth/client/plugins'
import { createAuthClient } from 'better-auth/react'
import { env } from '@/env.client'

export const authClient = createAuthClient({
  baseURL: env.VITE_CONVEX_SITE_URL,
  plugins: [
    convexClient(),
    crossDomainClient(),
    emailOTPClient(),
    organizationClient(),
    twoFactorClient(),
  ],
})
